var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 950,
    height: 950,
    viewBox: "0 0 950 950",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-432 -205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(432 205)",
    fill: "none",
    stroke: "#02b5ff",
    strokeWidth: 1,
    strokeDasharray: 6,
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 475,
    r: 475,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 475,
    r: 474.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(551 337)",
    fill: "none",
    stroke: "#02b5ff",
    strokeWidth: 1,
    strokeDasharray: 6,
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 350,
    r: 350,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 350,
    r: 349.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(711 467)",
    fill: "none",
    stroke: "#02b5ff",
    strokeWidth: 1,
    strokeDasharray: 6,
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 199.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseLines);
export default __webpack_public_path__ + "static/media/choose_lines.fd2b93a4351149d1ece65a4150535325.svg";
export { ForwardRef as ReactComponent };